module.exports = __webpack_public_path__ + "img/19_65.06c12b46.png";